import React, { Component } from "react";
import { createPortal } from "react-dom";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
// import DateTimePicker from "react-datetime-picker";
import {
	PiPaperPlaneTilt,
	PiCheckCircleFill,
	PiCaretRightBold,
	PiCalendarBlank,
} from "react-icons/pi";
import FollowUpConditionStep from "./steps/follow-up-condition-step";
import CampaignDetailsStep, { deriveVishingModeFromDetails } from "./steps/campaign-details-step";
import TemplateSelectionStep from "./steps/template-selection-step";
import TrainingSelectionStep from "./steps/training-selection-step";
import PreviewStep from "./steps/preview-step";
import CampaignPreview from "../create-template/campaign-preview/campaign-preview";
import swal from "sweetalert";
import axios from "../../axios";
import apiError from "../../error";
import { setCookie } from "../../function";
import Loader from "../loader/loader";
import runImm from "../../assets/create_campaign/runImm.png";
import runSchedule from "../../assets/create_campaign/runSchedule.png";
import "./launch-new-modal.css";
import { featuresObj } from "../../globalData";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CampaignScheduleDateInput = React.forwardRef(
	({ value, onClick, onChange, onFocus }, ref) => (
		<button
			type="button"
			className="campaign-run-mode-datepicker-trigger"
			onClick={onClick}
			onFocus={onFocus}
			ref={ref}
		>
			<span className="campaign-run-mode-datepicker-trigger__icon" aria-hidden="true">
				<PiCalendarBlank />
			</span>
			<input
				type="text"
				className="campaign-run-mode-datepicker-trigger__field"
				value={value}
				onChange={onChange}
				onClick={onClick}
				onFocus={onFocus}
				placeholder="DD/MM/YYYY / hh:mm"
				readOnly
			/>
		</button>
	)
);
CampaignScheduleDateInput.displayName = "CampaignScheduleDateInput";

const FOLLOW_UP_STEP_META = {
	condition: { title: "Condition", description: "Target users by behaviour" },
	configuration: { title: "Configuration", description: "Configure follow-up settings" },
	templateSelection: { title: "Template Selection", description: "Select the attack template" },
	trainingSelection: { title: "Training Selection", description: "Select the training course" },
	preview: { title: "Preview", description: "Verify details before launch" },
};

/** Fresh configuration each time the modal opens (toggles off; no stale merge from last session). */
const DEFAULT_FOLLOW_UP_CAMPAIGN_DETAILS = {
	campaignName: "",
	targetGroups: [],
	instantAwareness: false,
	userReply: false,
	credentialHarvesting: false,
	expiryDays: 7,
	customExpiryDate: null,
	awarenessTargetedGroup: "",
	timeFrame: "1",
	isRepliedCampaign: false,
	isAIbased: false,
	targetInteractionType: "",
};

const DEFAULT_FOLLOW_UP_TRAINING = {
	trainingAssignmentMode: "single",
	selectedCourses: [],
	selectedOptions: {},
	courseName: {},
	imageURL: "",
	sendCourseTemplateId: null,
	courseCompletionTemplateId: null,
	courseQuizFailReminderTemplateId: null,
	sendQuizTemplateId: null,
};

const coerceCredentialHarvesting = (raw) => {
	if (raw === true || raw === false) return raw;
	if (raw === 1 || raw === 0) return raw === 1;
	if (typeof raw === "string") {
		const s = String(raw).trim().toLowerCase();
		if (s === "true" || s === "1" || s === "yes" || s === "on") return true;
		if (s === "false" || s === "0" || s === "no" || s === "off" || s === "") return false;
	}
	return undefined;
};

export default class FollowUpCampaignModal extends Component {
	constructor(props) {
		super(props);
		this.stepRefs = {
			condition: null,
			configuration: null,
			templateSelection: null,
			trainingSelection: null,
			preview: null,
		};
		this.state = {
			currentStep: 1,
			highestStepReached: 1,
			progress: 0,
			conditions: [],
			conditionsDisplay: [],
			matchedUserCount: null,
			matchedUserCountLoading: false,
			parentSimulationId: "",
			totalUsers: null,
			campaignDetails: { ...DEFAULT_FOLLOW_UP_CAMPAIGN_DETAILS },
			training: { ...DEFAULT_FOLLOW_UP_TRAINING },
			templateType: "My Templates",
			templateSelectedCategory: "",
			templateSelectedCategoryIds: [],
			templateSelectionMode: "single",
			templateType: "My Templates",
			selectedTemplateIds: [],
			selectedTemplates: [],
			showRunModeModal: false,
			runMode: "immediately",
			scheduledDate: null,
			showTemplateDetailsModal: false,
			previewTemplateId: null,
			/** Full-screen overlay while POST /api/simulation/ (follow-up launch) is in flight. */
			submittingFollowUp: false,
			/** Full-screen overlay while GET /api/simulation/ (parent campaign context, on open) is in flight. */
			contextLoading: false,
			name: '',
			groups: [],
			groupIds: [],
			grouplist: [],
			nameError: false,
			userSelectError: false,
			campaignSelectError: false,
			date: new Date(),
			campaignCategory: [],
			campaignTemplate: [],
			campaignTemplates: [],
			campaignTemplateIds: [],
			campaignTemplateList: [],
			single: true,
			random: false,
			frequency: 'One Time',
			period: '',
			selectedTeplate: {},
			showModal: false,
			showTestModal: false,
			previewSrc: '',
			emails: '',
			previewType: '',
			categoryCount: {},
			templateName: null,
			selectedOption: '',
			lmsDelay: new Date(new Date().setMinutes(new Date().getMinutes() + 300)),
			disabledSendNowButton: false,
			overview: [],
			campaigns: [],
			simulationId: 0,
			simulationState1: null,
			simulationState2: null,
			sendCampaignOnOldSimulation: false,
			// attackType: this.props.match.params.attackType,
			// credentialHarvesting: this.props.match.params.ch,
			// simulationType: this.props.match.params.simulationType,
			// templateId: this.useQuery().get('ctID') ? this.useQuery().get('ctID') : '0',
			// category: this.useQuery().get('category') ? this.useQuery().get('category') : '',
			// type: this.useQuery().get('type') ? this.useQuery().get('type') : 'My Templates',
			copySuccess: '',
			identifier: '',
			campaginTypeModal: true,
			firstname: '',
			lastname: '',
			lmsMsgStatus: '',
			isRepliedCampaign: false,
			campaignTemplateDetails: [],
			selectedOptions: [],
			userReplyFeature: featuresObj['reply-tracking-over-phishing'],
			isInstantAwareness: false,
			expiryDays: 7,
			customExpiryDate: null,
			targetInteractionType: "inbound",
		};

	}

	componentDidUpdate(prevProps) {
		if (!prevProps.showModal && this.props.showModal) {
			this.resetModal();
			// Seed attackType, simulationType, credentialHarvesting from parent so TemplateSelectionStep has them.
			// Merge WhatsApp/Vishing mode into campaignDetails so Configuration shows Direct vs AI correctly.
			const { attackType, simulationType, credentialHarvesting, targetInteractionType, isAIbased } = this.props;
			const modeSeed = deriveVishingModeFromDetails({
				isAIbased,
				targetInteractionType,
			});
			if (attackType || simulationType) {
				this.setState({
					attackType: attackType || "",
					simulationType: simulationType || "",
					credentialHarvesting: credentialHarvesting ?? false,
					targetInteractionType: modeSeed.targetInteractionType || "",
					campaignDetails: {
						...DEFAULT_FOLLOW_UP_CAMPAIGN_DETAILS,
						...modeSeed,
					},
				});
			} else if (this.props.campaignId && this.props.simulationId) {
				this.fetchCampaignContext();
			}
		}
	}

	fetchCampaignContext = () => {
		const { campaignId, simulationId } = this.props;
		if (!campaignId || !simulationId) return;
		this.setState({ contextLoading: true });
		axios.get("/api/simulation/", {
			params: { campaignId, simulationId }
		})
			.then((res) => {
				this.setState({ contextLoading: false });
				if (res.data?.simulation?.campaign) {
					const sim = res.data.simulation;
					const camp = sim.campaign;
					const attackType = camp.attack_type?.name || "";
					const simulationType = (sim.simulation_type?.name || camp.simulation_type?.name || "").trim();
					const chRaw =
						camp.credential_harvesting ??
						camp.credentialHarvesting ??
						sim.credential_harvesting ??
						sim.credentialHarvesting;
					const credentialHarvesting = coerceCredentialHarvesting(chRaw) ?? false;
					const modeSeed = deriveVishingModeFromDetails({
						isAIbased: this.props.isAIbased,
						targetInteractionType: this.props.targetInteractionType,
					});
					this.setState((prev) => ({
						attackType,
						simulationType,
						credentialHarvesting,
						targetInteractionType: modeSeed.targetInteractionType || "",
						campaignDetails: {
							...prev.campaignDetails,
							...modeSeed,
						},
					}));
				}
			})
			.catch(() => {
				this.setState({ contextLoading: false });
			});
	};

	resetModal = () => {
		this.setState({
			currentStep: 1,
			highestStepReached: 1,
			progress: 0,
			simulationType: "",
			attackType: "",
			credentialHarvesting: false,
			conditions: [],
			conditionsDisplay: [],
			totalUsers: null,
			campaignDetails: { ...DEFAULT_FOLLOW_UP_CAMPAIGN_DETAILS },
			training: { ...DEFAULT_FOLLOW_UP_TRAINING },
			templateId: null,
			templateType: "My Templates",
			templateSelectedCategory: "",
			templateSelectedCategoryIds: [],
			templateSelectionMode: "single",
			templateType: "My Templates",
			selectedTemplateIds: [],
			selectedTemplates: [],
			showRunModeModal: false,
			runMode: "immediately",
			scheduledDate: null,
			showTemplateDetailsModal: false,
			previewTemplateId: null,
			submittingFollowUp: false,
			contextLoading: false,
			identifier: this.generateCampaignIdentifier(),
			matchedUserCount: null,
			matchedUserCountLoading: false,
			parentSimulationId: "",
			simulationState1: null,
			simulationState2: null,
		});
	};

	hasTrainingStep = () => {
		return this.getSimulationType() === "Simulation Attack + Training";
	};

	getSimulationType = () =>
		String(this.props.simulationType || this.state.simulationType || "").trim();

	getStepKeys = () => {
		const keys = ["condition", "configuration", "templateSelection"];
		if (this.hasTrainingStep()) keys.push("trainingSelection");
		keys.push("preview");
		return keys;
	};

	getSteps = () =>
		this.getStepKeys().map((key, index) => ({
			key,
			number: index + 1,
			...FOLLOW_UP_STEP_META[key],
		}));

	getTotalSteps = () => this.getStepKeys().length;

	getStepKey = (stepNumber) => this.getStepKeys()[stepNumber - 1];

	updateProgress = () => {
		const { currentStep } = this.state;
		const total = this.getTotalSteps();
		const progress = Math.round((currentStep / total) * 100);
		this.setState({ progress });
	};

	isTemplateStepValid = () => {
		const mode = this.state.templateSelectionMode || "single";
		const hasSingle = this.state.templateId != null && this.state.templateId !== "";
		const selectedCount = Array.isArray(this.state.selectedTemplateIds) ? this.state.selectedTemplateIds.length : 0;
		return mode === "single" ? hasSingle : selectedCount > 1;
	};

	/** Single needs one course; Multiple needs at least two. */
	isTrainingStepValid = () => {
		const training = this.state.training || {};
		const mode = training.trainingAssignmentMode || "single";
		const selectedCount = Array.isArray(training.selectedCourses) ? training.selectedCourses.length : 0;
		return mode === "single" ? selectedCount >= 1 : selectedCount > 1;
	};

	handleStepChange = (step) => {
		if (this.state.submittingFollowUp) return;
		if (step < 1 || step > this.getTotalSteps()) return;
		if (step > this.state.highestStepReached) return;
		this.setState({ currentStep: step }, () => this.updateProgress());
	};

	handleNext = () => {
		if (this.state.submittingFollowUp) return;
		const currentKey = this.getStepKey(this.state.currentStep);
		if (
			currentKey === "templateSelection" &&
			this.stepRefs.templateSelection &&
			typeof this.stepRefs.templateSelection.updateData === "function"
		) {
			this.stepRefs.templateSelection.updateData();
		}
		if (
			currentKey === "trainingSelection" &&
			this.stepRefs.trainingSelection &&
			typeof this.stepRefs.trainingSelection.pushUpdate === "function"
		) {
			this.stepRefs.trainingSelection.pushUpdate();
		}

		let valid = false;
		switch (currentKey) {
			case "condition":
				valid =
					this.stepRefs.condition && this.stepRefs.condition.validate
						? this.stepRefs.condition.validate()
						: false;
				break;
			case "configuration":
				valid =
					this.stepRefs.configuration && this.stepRefs.configuration.validate
						? this.stepRefs.configuration.validate()
						: true;
				break;
			case "templateSelection": {
				valid = this.isTemplateStepValid();
				if (!valid) {
					const mode = this.state.templateSelectionMode || "single";
					toast.error(mode === "random" ? "Please select at least two templates" : "Please select a template");
				}
				break;
			}
			case "trainingSelection":
				valid =
					this.stepRefs.trainingSelection && this.stepRefs.trainingSelection.validate
						? this.stepRefs.trainingSelection.validate()
						: false;
				break;
			case "preview":
				valid = true;
				break;
			default:
				valid = false;
		}

		if (valid) {
			if (this.state.currentStep < this.getTotalSteps()) {
				const nextStep = this.state.currentStep + 1;
				this.setState(
					(prev) => ({
						currentStep: nextStep,
						highestStepReached: Math.max(prev.highestStepReached || 1, nextStep)
					}),
					() => this.updateProgress()
				);
			} else {
				this.setState({ showRunModeModal: true }, () => this.updateProgress());
			}
		}
	};

	handleBack = () => {
		if (this.state.submittingFollowUp) return;
		if (this.state.currentStep > 1) {
			this.handleStepChange(this.state.currentStep - 1);
		}
	};

	handleClose = () => {
		if (this.state.submittingFollowUp || this.state.contextLoading) return;
		this.setState({ showRunModeModal: false, scheduledDate: null });
		if (this.props.onClose) this.props.onClose();
	};

	handleRunModeCancel = () => {
		this.setState({ showRunModeModal: false, scheduledDate: null }, () => this.updateProgress());
	};

	getScheduledAt = () => {
		if (this.state.runMode === "schedule") {
			const sd = this.state.scheduledDate;
			if (sd && new Date(sd) > new Date()) return sd instanceof Date ? sd : new Date(sd);
			return null;
		}
		return new Date();
	};

	calculateCampaignExpiry = (scheduledAt) => {
		const scheduledDate = new Date(scheduledAt);
		const cd = this.state.campaignDetails || {};
		const expiryDays = cd?.expiryDays;
		const customExpiryDate = cd?.customExpiryDate;
		if (expiryDays === 7) {
			const expiryDate = new Date(scheduledDate);
			expiryDate.setDate(expiryDate.getDate() + 7);
			return expiryDate.toISOString();
		}
		if (expiryDays === 15) {
			const expiryDate = new Date(scheduledDate);
			expiryDate.setDate(expiryDate.getDate() + 15);
			return expiryDate.toISOString();
		}
		if (expiryDays === "custom" && customExpiryDate) {
			const expiryDate = new Date(customExpiryDate);
			return isNaN(expiryDate.getTime()) ? null : expiryDate.toISOString();
		}
		return null;
	};

	/** Unique campaign request id for API (always non-empty when used in payload). */
	generateCampaignIdentifier = () => {
		const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		let result = "";
		for (let i = 0; i < 30; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return result;
	};

	buildTrainingPayload = () => {
		if (!this.hasTrainingStep()) return undefined;

		const training = this.state.training || {};
		const selectedOptions = {};
		(training.selectedCourses || []).forEach((courseId) => {
			selectedOptions[courseId] =
				(training.selectedOptions && training.selectedOptions[courseId]) || {};
		});
		if (Object.keys(selectedOptions).length === 0) return undefined;

		return {
			trainingAssignmentMode: training.trainingAssignmentMode || "single",
			selectedOptions,
			sendCourseTemplateId: training.sendCourseTemplateId || null,
			courseCompletionTemplateId: training.courseCompletionTemplateId || null,
			courseQuizFailReminderTemplateId: training.courseQuizFailReminderTemplateId || null,
			sendQuizTemplateId: training.sendQuizTemplateId || null,
		};
	};

	handleRunModeSubmit = () => {
		const runMode = this.state.runMode;
		const scheduledAt = this.getScheduledAt();
		if (runMode === "schedule") {
			if (!scheduledAt || new Date(scheduledAt) <= new Date()) {
				toast.error("Please select a date and time in the future");
				return;
			}
		}
		const credentialHarvesting =
			this.state.campaignDetails?.credentialHarvesting ??
			this.props.credentialHarvesting ??
			false;
		const simulationType = this.getSimulationType();
		const attackType = this.props.attackType ?? this.state.attackType;
		const isSingle = this.state.templateSelectionMode === "single";
		const scheduledAtISO = scheduledAt instanceof Date ? scheduledAt.toISOString() : (scheduledAt ? new Date(scheduledAt).toISOString() : new Date().toISOString());
		const selectedIds = Array.isArray(this.state.selectedTemplateIds) ? this.state.selectedTemplateIds : [];
		// API expects a primary id: single uses templateId; random uses first selected (TemplateSelectionStep also sets templateId to selectedIds[0]).
		const campaignTemplateId =
			isSingle
				? (this.state.templateId != null && this.state.templateId !== "" ? this.state.templateId : null)
				: (selectedIds.length ? selectedIds[0] : (this.state.templateId != null && this.state.templateId !== "" ? this.state.templateId : null));

		const identifier = String(this.state.identifier || "").trim() || this.generateCampaignIdentifier();
		const training = this.buildTrainingPayload();

		const payload = {
			attackType: attackType || "Phishing",
			simulationType: simulationType || "Simulation Attack",
			credentialHarvesting: credentialHarvesting === true || credentialHarvesting === "true",
			// campaignId: this.props.campaignId,
			simulationId: (this.state.parentSimulationId && String(this.state.parentSimulationId).trim() !== "")
				? String(this.state.parentSimulationId).trim()
				: this.props.simulationId,
			sendCampaignOnOldSimulation: true,
			// conditions: this.state.conditions,
			// conditionsDisplay: this.state.conditionsDisplay,
			campaignName: "Follow-Up Campaign",
			campaignTemplateId,
			campaignTemplateIds: !isSingle ? selectedIds.slice(1) : [],
			campaignType: runMode === "test" ? "test" : "live",
			single: isSingle,
			random: !isSingle,
			groupIds: [],
			// category: "",
			identifier,
			// type: "My Templates",
			scheduledAt: scheduledAtISO,
			// lmsDelay: scheduledAtISO,
			lmsMsgStatus: this.state.campaignDetails.awarenessTargetedGroup || "",
			isInstantAwareness: this.state.campaignDetails.instantAwareness,
			isRepliedCampaign: this.state.campaignDetails.userReply,
			campaignExpiry: this.calculateCampaignExpiry(scheduledAt),
			simulationState: null,
			simulationState1: this.state.simulationState1,
			simulationState2: this.state.simulationState2,
			delay: this.state.campaignDetails.timeFrame || "1",
			...(training ? { training } : {}),
			// targetInteractionType: targetInteractionType || "inbound"
		};

		this.setState({ showRunModeModal: false, scheduledDate: null, submittingFollowUp: true });

		if (this.state.templateType === "System Templates") {
			this.cloneSystemTemplatesThenLaunch(payload, isSingle, selectedIds);
			return;
		}

		this.submitFollowUp(payload);
	};


	submitFollowUp = (payload) => {
		axios
			.post("/api/simulation/", payload)
			.then((res) => {
				this.setState({ submittingFollowUp: false });
				setCookie("isDashboard", true, 30000);
				toast.success("Follow-up campaign launched successfully");
				if (this.props.onClose) this.props.onClose();
				if (this.props.onSuccess) this.props.onSuccess(res);
			})
			.catch((err) => {
				this.setState({ submittingFollowUp: false });
				apiError(err);
			});
	};

	cloneSystemTemplatesThenLaunch = (payload, isSingle, selectedIds) => {
		const sourceIds = isSingle
			? (payload.campaignTemplateId != null ? [payload.campaignTemplateId] : [])
			: ((Array.isArray(selectedIds) ? selectedIds : []).filter((v) => v != null));
		if (!sourceIds.length) {
			this.setState({ submittingFollowUp: false });
			toast.error("Please select a template");
			return;
		}
		Promise.all(
			sourceIds.map((id) =>
				axios.post("/api/store/clone-campaign-template/" + id, {}).then((res) => ({
					clonedId: res.data.campaignTemplateId != null ? res.data.campaignTemplateId : res.data.response?.id,
					status: res.data.status
				}))
			)
		)
			.then((results) => {
				const clonedIds = results.map((r) => r.clonedId).filter((v) => v != null);
				if (clonedIds.length !== sourceIds.length) {
					this.setState({ submittingFollowUp: false });
					toast.error("Failed to clone the selected system template");
					return;
				}
				const draft = results.find((r) => (r.status || "").toLowerCase() === "draft");
				if (draft) {
					this.setState({ submittingFollowUp: false });
					swal({
						title: "Template Cloned",
						text: "This system template has been cloned to your templates, but it is still a draft. Please review and save the cloned template before running the follow-up campaign.",
						icon: "info"
					});
					return;
				}
				
				const clonedPayload = {
					...payload,
					campaignTemplateId: clonedIds[0],
					campaignTemplateIds: isSingle ? [] : clonedIds.slice(1)
				};
				this.submitFollowUp(clonedPayload);
			})
			.catch((err) => {
				this.setState({ submittingFollowUp: false });
				apiError(err);
			});
	};

	updateConditionStep = (data) => {
		if (typeof data !== "object" || data === null) return;
		this.setState((prev) => {
			const next = { ...prev };
			if (data.hasOwnProperty("matchedUserCount")) next.matchedUserCount = data.matchedUserCount;
			if (data.hasOwnProperty("matchedUserCountLoading")) next.matchedUserCountLoading = data.matchedUserCountLoading;
			if (data.hasOwnProperty("parentSimulationId")) {
				next.parentSimulationId =
					data.parentSimulationId != null && String(data.parentSimulationId).trim() !== ""
						? String(data.parentSimulationId).trim()
						: "";
			}
			if (data.hasOwnProperty("conditions")) {
				next.conditions = data.conditions;
				const filledConditions = Array.isArray(data.conditions) ? data.conditions.filter(c => c && c.event) : [];
				next.simulationState1 = filledConditions[0]?.event || null;
				next.simulationState2 = filledConditions[1]?.event || null;
				next.conditionsDisplay = data.hasOwnProperty("conditionsDisplay")
					? data.conditionsDisplay
					: (data.conditions || prev.conditionsDisplay);
			} else if (data.hasOwnProperty("conditionsDisplay")) {
				next.conditionsDisplay = data.conditionsDisplay;
			}
			return next;
		}, () => this.updateProgress());
	};

	updateConfigStep = (data) => {
		const nextDetails = { ...this.state.campaignDetails, ...data };
		const credentialHarvestingChanged = data.hasOwnProperty("credentialHarvesting") && nextDetails.credentialHarvesting !== this.state.campaignDetails.credentialHarvesting;
		this.setState({
			campaignDetails: nextDetails,
			...(credentialHarvestingChanged ? { templateId: null, selectedTemplateIds: [], selectedTemplates: [] } : {})
		}, () => this.updateProgress());
	};


	updateTemplateStep = (payload) => {
		if (typeof payload !== "object" || payload === null) return;
		const nextTemplates =
			payload.hasOwnProperty("selectedTemplates") && Array.isArray(payload.selectedTemplates)
				? payload.selectedTemplates
				: this.state.selectedTemplates;
		let templateId = payload.hasOwnProperty("templateId") ? payload.templateId : this.state.templateId;
		let selectedTemplateIds = payload.hasOwnProperty("selectedTemplateIds")
			? payload.selectedTemplateIds || []
			: this.state.selectedTemplateIds;
		if (Array.isArray(nextTemplates) && nextTemplates.length === 0) {
			templateId = null;
			selectedTemplateIds = [];
		}

		let templateSelectedCategory = this.state.templateSelectedCategory;
		let templateSelectedCategoryIds = this.state.templateSelectedCategoryIds || [];
		if (payload.hasOwnProperty("selectedCategoryIds") && Array.isArray(payload.selectedCategoryIds)) {
			templateSelectedCategoryIds = [...payload.selectedCategoryIds];
			templateSelectedCategory =
				templateSelectedCategoryIds.length > 0 ? templateSelectedCategoryIds[0] : "";
		} else if (payload.hasOwnProperty("selectedCategory")) {
			const sc = payload.selectedCategory;
			if (sc != null && sc !== "") {
				templateSelectedCategory = sc;
				templateSelectedCategoryIds = [sc];
			} else {
				templateSelectedCategory = "";
				templateSelectedCategoryIds = [];
			}
		}

		this.setState({
			templateId,
			templateType: payload.templateType != null ? payload.templateType : this.state.templateType,
			templateSelectedCategory,
			templateSelectedCategoryIds,
			templateSelectionMode: payload.templateMode != null ? payload.templateMode : this.state.templateSelectionMode,
			templateType: payload.hasOwnProperty("templateType")
				? (payload.templateType === "System Templates" ? "System Templates" : "My Templates")
				: this.state.templateType,
			selectedTemplateIds,
			selectedTemplates: nextTemplates
		}, () => this.updateProgress());
	};

	updateTrainingStep = (payload) => {
		this.setState(
			(prev) => ({ training: { ...prev.training, ...payload } }),
			() => this.updateProgress()
		);
	};

	proceedFromTraining = () => {
		if (this.state.currentStep < this.getTotalSteps()) {
			const nextStep = this.state.currentStep + 1;
			this.setState(
				(prev) => ({
					currentStep: nextStep,
					highestStepReached: Math.max(prev.highestStepReached || 1, nextStep),
				}),
				() => this.updateProgress()
			);
		}
	};

	renderStepContent = () => {
		const { campaignDetails } = this.state;
		// Parent campaign context for type / template APIs (not the same as fresh campaignDetails toggles on step 2).
		const simulationType = this.getSimulationType();
		const attackType = this.props.attackType ?? this.state.attackType;
		const credentialHarvestingForTemplates =
			this.props.credentialHarvesting ?? this.state.credentialHarvesting ?? false;
		switch (this.getStepKey(this.state.currentStep)) {
			case "condition":
				return (
					<FollowUpConditionStep
						ref={(ref) => (this.stepRefs.condition = ref)}
						conditions={this.state.conditions}
						parentSimulationId={this.state.parentSimulationId}
						matchedUserCount={this.state.matchedUserCount}
						matchedUserCountLoading={this.state.matchedUserCountLoading}
						attackType={attackType}
						credentialHarvesting={credentialHarvestingForTemplates}
						targetInteractionType={this.state.targetInteractionType}
						onUpdate={this.updateConditionStep}
						simulationId={this.props.simulationId}
						simulationState1={this.state.simulationState1}
						simulationState2={this.state.simulationState2}
						simulations={this.props.simulations}
					/>
				);
			case "configuration":
				return (
					<CampaignDetailsStep
						ref={(ref) => (this.stepRefs.configuration = ref)}
						followUpMode={true}
						campaignDetails={campaignDetails}
						simulationType={simulationType}
						attackType={attackType}
						onUpdate={this.updateConfigStep}
					/>
				);
			case "templateSelection":
				return (
					<TemplateSelectionStep
						ref={(ref) => (this.stepRefs.templateSelection = ref)}
						templateId={this.state.templateId}
						templateType={this.state.templateType}
						selectedCategory={this.state.templateSelectedCategory}
						selectedCategoryIds={this.state.templateSelectedCategoryIds}
						selectedTemplateIds={this.state.selectedTemplateIds}
						templateMode={this.state.templateSelectionMode}
						simulationType={simulationType}
						attackType={attackType}
						credentialHarvesting={credentialHarvestingForTemplates}
						campaignDetails={campaignDetails}
						campaignId={this.props.campaignId}
						simulationId={this.props.simulationId}
						onUpdate={this.updateTemplateStep}
						onPreviewTemplate={(templateId) => this.setState({ showTemplateDetailsModal: true, previewTemplateId: templateId })}
					/>
				);
			case "trainingSelection":
				return (
					<TrainingSelectionStep
						ref={(ref) => (this.stepRefs.trainingSelection = ref)}
						training={this.state.training}
						onUpdate={this.updateTrainingStep}
						onProceed={this.proceedFromTraining}
					/>
				);
			case "preview":
				return (
					<PreviewStep
						ref={(ref) => (this.stepRefs.preview = ref)}
						allData={{
							followUpMode: true,
							simulationType,
							attackType,
							credentialHarvesting: credentialHarvestingForTemplates,
							campaignDetails: { ...campaignDetails, campaignName: "Follow-Up Campaign" },
							templateId: this.state.templateId,
							selectedTemplates: this.state.selectedTemplates,
							training: this.state.training,
							conditions: this.state.conditionsDisplay,
							totalUsers: this.state.totalUsers
						}}
					/>
				);
			default:
				return null;
		}
	};

	render() {
		const { showModal } = this.props;
		const { currentStep, progress, matchedUserCount, matchedUserCountLoading, parentSimulationId, conditions } =
			this.state;
		const hasTargetCampaign = !!(parentSimulationId != null && String(parentSimulationId).trim() !== "");
		const firstCondition = Array.isArray(conditions) ? conditions.find((c) => c && c.event) : null;
		const hasPrimaryEvent = !!(firstCondition && firstCondition.event);
		const hasUsersMatched =
			typeof matchedUserCount === "number" && Number.isFinite(matchedUserCount) && matchedUserCount > 0;
		const conditionStepIncomplete =
			!hasTargetCampaign ||
			!hasPrimaryEvent ||
			matchedUserCountLoading === true ||
			matchedUserCount === null ||
			!hasUsersMatched;
		const currentStepKey = this.getStepKey(currentStep);
		const totalSteps = this.getTotalSteps();
		const followUpSteps = this.getSteps();
		const continueDisabled =
			(currentStepKey === "condition" && conditionStepIncomplete) ||
			(currentStepKey === "templateSelection" && !this.isTemplateStepValid()) ||
			(currentStepKey === "trainingSelection" && !this.isTrainingStepValid());

		if (!showModal) return null;

		const { submittingFollowUp, contextLoading } = this.state;
		const launchLoader =
			typeof document !== "undefined" &&
			submittingFollowUp &&
			createPortal(<Loader />, document.body);
		/** Full-screen overlay while the parent campaign's attack/simulation type is still loading (open was slow). */
		const contextLoader =
			typeof document !== "undefined" &&
			contextLoading &&
			createPortal(<Loader />, document.body);

		return (
			<>
				{launchLoader}
				{contextLoader}
				<Modal
					show={showModal}
					onHide={this.handleClose}
					backdrop={submittingFollowUp || contextLoading ? "static" : true}
					keyboard={!submittingFollowUp && !contextLoading}
					className="campaign-creation-modal"
					dialogClassName="modal-dialog modal-90w campaign-modal-dialog"
					size="xl"
					centered
				>
					<Modal.Header closeButton className="campaign-modal-header">
						<div className="campaign-modal-header-inner">
							<div className="campaign-modal-title">
								<h5 className="campaign-modal-title-text">Follow-Up Campaign</h5>
								<div className="progress-indicator">
									<span>{this.state.progress}% Complete</span>
								</div>
							</div>
							<div className="campaign-modal-progress-bar">
								<div className="campaign-modal-progress-track">
									<div
										className="campaign-modal-progress-fill"
										style={{ width: `${progress}%` }}
									/>
								</div>
							</div>
						</div>
					</Modal.Header>
					<Modal.Body className="campaign-modal-body">
						<div className="campaign-modal-container">
							<div className="campaign-sidebar">
								{followUpSteps.map((step) => (
									<div
										key={step.key}
										className={`step-item ${currentStep === step.number ? "active" : ""} ${currentStep > step.number ? "completed" : ""} ${step.number > this.state.highestStepReached ? "disabled" : ""}`}
										onClick={() => this.handleStepChange(step.number)}
										style={
											submittingFollowUp
												? { opacity: 0.55, cursor: "not-allowed", pointerEvents: "none" }
												: step.number > this.state.highestStepReached
													? { opacity: 0.55, cursor: "not-allowed", pointerEvents: "none" }
													: undefined
										}
									>
										<div className="step-number">
											{currentStep > step.number ? (
												<PiCheckCircleFill className="step-completed-icon" />
											) : (
												<span className="step-number-circle">{step.number}</span>
											)}
										</div>
										<div className="step-content">
											<div className="step-title">{step.title}</div>
											<div className="step-description">
												{currentStep > step.number ? "Completed" : step.description}
											</div>
										</div>
									</div>
								))}
							</div>
							<div className="campaign-main-content">
								{this.renderStepContent()}
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer className="campaign-modal-footer">
						{currentStep > 1 && (
							<Button variant="secondary" className="previous-button" onClick={this.handleBack} disabled={submittingFollowUp}>
								Previous
							</Button>
						)}
						<Button
							variant="primary"
							onClick={this.handleNext}
							className="continue-button"
							disabled={continueDisabled || submittingFollowUp}
							title={
								continueDisabled && currentStepKey === "condition"
									? !hasTargetCampaign
										? "Select a target campaign"
										: !hasPrimaryEvent
											? "Select an event"
											: matchedUserCountLoading
												? "Loading matched user count…"
												: matchedUserCount === null
													? "Waiting for matched user count"
													: matchedUserCount === 0
													? "No users match these conditions"
													: undefined
									: continueDisabled && currentStepKey === "templateSelection"
										? "Select at least two templates in Multiple mode"
										: continueDisabled && currentStepKey === "trainingSelection"
											? (this.state.training?.trainingAssignmentMode === "multiple"
												? "Select at least two training courses in Multiple mode"
												: "Select a training course")
											: undefined
							}
						>
							{currentStep === totalSteps ? (
								<>
									<PiPaperPlaneTilt className="run-campaign-icon" />
									Run Campaign
								</>
							) : (
								<>Continue <PiCaretRightBold /></>
							)}
						</Button>
					</Modal.Footer>
				</Modal>

				{this.state.currentStep === this.getTotalSteps() && this.state.showRunModeModal && (
					<Modal
						show={true}
						onHide={this.handleRunModeCancel}
						backdrop="static"
						className="campaign-run-mode-modal"
						dialogClassName="campaign-run-mode-dialog"
						centered
					>
						<div className="campaign-run-mode-header">
							<div className="campaign-run-mode-header-content">
								<h5 className="campaign-run-mode-title">Campaign Run Mode</h5>
								<p className="campaign-run-mode-subtitle">Select the preferred execution mode for this campaign</p>
							</div>
							<button type="button" className="campaign-run-mode-close" onClick={this.handleRunModeCancel} aria-label="Close">
								×
							</button>
						</div>
						<Modal.Body className="campaign-run-mode-body">
							<div
								className={`campaign-run-mode-option ${this.state.runMode === "immediately" ? "selected" : ""}`}
								onClick={() => this.setState({ runMode: "immediately" })}
							>
								<div className="campaign-run-mode-option-icon">
									<img src={runImm} alt="Run Immediately" />
								</div>
								<div className="campaign-run-mode-option-content">
									<h6 className="campaign-run-mode-option-title">Run Immediately</h6>
									<p className="campaign-run-mode-option-desc">Begin the campaign right away</p>
								</div>
								<Form.Check
									type="radio"
									name="runMode"
									checked={this.state.runMode === "immediately"}
									onChange={() => this.setState({ runMode: "immediately" })}
									onClick={(e) => e.stopPropagation()}
								/>
							</div>
							<div
								className={`campaign-run-mode-option campaign-run-mode-option-schedule ${this.state.runMode === "schedule" ? "selected" : ""} ${this.state.runMode === "schedule" ? "has-datetime" : ""}`}
								onClick={() => this.setState({ runMode: "schedule" })}
							>
								<div className="campaign-run-mode-option-row">
									<div className="campaign-run-mode-option-icon">
										<img src={runSchedule} alt="Schedule for Later" />
									</div>
									<div className="campaign-run-mode-option-content">
										<h6 className="campaign-run-mode-option-title">Schedule for Later</h6>
										<p className="campaign-run-mode-option-desc">Set a specific date and time for the campaign to start</p>
									</div>
									<Form.Check
										type="radio"
										name="runMode"
										checked={this.state.runMode === "schedule"}
										onChange={() => this.setState({ runMode: "schedule" })}
										onClick={(e) => e.stopPropagation()}
									/>
								</div>
								{this.state.runMode === "schedule" && (
									<div
										className="campaign-run-mode-schedule-picker-inline campaign-run-mode-schedule-picker-inline--datepicker"
										onClick={(e) => e.stopPropagation()}
									>
										<div className="campaign-run-mode-datepicker-input-shell">
											<DatePicker
												id="follow-up-campaign-scheduled-start"
												selected={this.state.scheduledDate}
												onChange={(date) =>
													this.setState({ scheduledDate: date })
												}
												minDate={new Date()}
												showTimeInput
												timeInputLabel="Time"
												dateFormat="MM/dd/yyyy h:mm aa"
												customInput={<CampaignScheduleDateInput />}
												calendarClassName="campaign-run-mode-datepicker-calendar"
												popperClassName="campaign-run-mode-datepicker-popper"
												popperPlacement="top-start"
												popperModifiers={{
													offset: {
														enabled: true,
														offset: "0, 10",
													},
												}}
											/>
										</div>
									</div>
								)}
							</div>
						</Modal.Body>
						<div className="campaign-run-mode-footer">
							<Button variant="secondary" className="previous-button" onClick={this.handleRunModeCancel}>
								Cancel
							</Button>
							<Button
								variant="primary"
								onClick={this.handleRunModeSubmit}
								className="continue-button"
								disabled={submittingFollowUp}
							>
								Run Campaign
							</Button>
						</div>
					</Modal>
				)}

				{this.state.showTemplateDetailsModal && this.state.previewTemplateId && (
					<CampaignPreview
						show={this.state.showTemplateDetailsModal}
						campaignTemplateId={this.state.previewTemplateId}
						campaignType={this.state.templateType === "System Templates" ? "System Templates" : "My Templates"}
						keyType={this.state.templateType === "System Templates" ? "system" : "templates"}
						fromCampaign={true}
						dimCredentialHarvestingSections={true}
						credentialHarvestingOverride={this.state.campaignDetails?.credentialHarvesting ?? this.props.credentialHarvesting ?? false}
						handleModal={() => this.setState({ showTemplateDetailsModal: false, previewTemplateId: null })}
						nextPath={() => { }}
						load={() => { }}
					/>
				)}
			</>
		);
	}
}
